import { get, post } from '../lib/apiClient';

/** GET /notifications — the caller's feed */
export const listNotifications = (query) => get('/notifications', { query });

/**
 * GET /notifications/unread — unread page plus the total `unreadCount`.
 * The badge only needs the count, so it passes `{ limit: 1 }`.
 */
export const listUnread = (query) => get('/notifications/unread', { query });

/** POST /notifications/{notificationId}/read */
export const markRead = (notificationId) =>
  post(`/notifications/${encodeURIComponent(notificationId)}/read`);

/** POST /notifications/{notificationId}/dismiss */
export const dismiss = (notificationId) =>
  post(`/notifications/${encodeURIComponent(notificationId)}/dismiss`);

/** POST /notifications/read-all */
export const markAllRead = () => post('/notifications/read-all');

/**
 * POST /notifications — admin-only announcement fan-out. `body` is
 * `{ recipients, type, priority, subject, message, actionUrl? }`; the
 * backend restricts `type` to `general_announcement`/`escalation_event`
 * and 403s non-admins.
 */
export const create = (body) => post('/notifications', body);
